
import React from 'react';
import { TextField, FormControl, Grid, Typography, Card, CardContent, Button, IconButton, InputAdornment, useFormControl, FormHelperText, Box } from '@mui/material';
import { UserRegisterT } from './RegisterScreen';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import NumberFormat, { NumberFormatProps } from 'react-number-format';
import NumberFormatCustom from '../../components/NumberFormatCustom';
import TextFieldValidate from '../../components/TextFieldValidate';
import { isEmail, validatePassword } from '../../utils/validator'
import { numberPhoneIsValid } from '../../utils/utilsT';
import Validator from 'jsonschema'

import config from '../../constants/config';
import GoogleMapAutoComplete from '../../components/MapBoxAutoComplete/GoogleMapAutoComplete';



var schema = {
    "id": "/addressTab",
    "type": "object",
    "properties": {
        "address": { "type": "string", "minLength": 2 },
        "address2": { "type": "string" },
    },
    "required": ["address"]
};


export type IAddressTabProps = {
    fields: UserRegisterT
    onChangeField(key: string, value: any): void
    nextTab(fields: UserRegisterT): void

}

const AddressTab: React.FC<IAddressTabProps> = (props) => {

    const [showPassword, setShowPassword] = React.useState(false)
    const [showRePassword, setShowRePassword] = React.useState(false)

    const validatorRef = React.useRef(new Validator.Validator())


    React.useEffect(() => {
        validatorRef.current = new Validator.Validator()
    }, []);


    const onChangeField = (key: string, value: any): void => {
        props.onChangeField(key, value)

    }
    const getValue = (key, fields) => {
        return fields[key] && fields[key] != null ? fields[key] : ""
    }


    const checkValidate = React.useCallback((params: UserRegisterT) => {
        if (!validatorRef || !validatorRef.current) {
            return false
        }
        const valid = validatorRef.current.validate(params, schema)
        if (!valid.valid) {
            return false
        }
        return true
    }, [props.fields]);





    const next = async (params: any): Promise<string> => {
        try {

            if (checkValidate(params)) {
                props.nextTab(params)
                return ""
            }
        } catch (error) {
            throw error
        }
    }

    return (
        <Box>

            {/* <CardContent style={{ justifyContent: "center", display: "flex" }}> */}

            <Grid container spacing={3} mt={2} xs={12}>
                <Grid item xs={12}>

                    <GoogleMapAutoComplete
                        placeholder='Enter a location *'
                        // idAddresss={`addressLoction-${uniqueId}`}
                        customInput={TextFieldValidate}
                        // className={` ${ea.textField}`}
                        fullWidth
                        required
                        InputProps={{
                            // disableUnderline: true,
                            variant: "standard",
                            onError: (value) => {
                                return value == "" ? "Required" : ""
                            }
                        }}
                        label="Address"
                        variant="standard"
                        menuPortal={{
                            menuPlacement: 'top',
                            menuPosition: "absolute",

                        }}

                        apiKey={config.keyMap}
                        onChangeText={text => { }}
                        onPress={async location => {
                            onChangeField("address", location.verbose_address)

                            console.log("location", location)

                        }}

                        textValue={`${props.fields.address}`}
                        onValidateError={(value) => {
                            return value == "" ? "Required" : ""
                        }}
                    />

                </Grid>
                <Grid item xs={12}>
                    <TextFieldValidate fullWidth
                        variant="standard"
                        name="address2"
                        label="Unit"
                        value={`${getValue("address2", props.fields)}`}
                        onChange={(event: any) => {
                            let value = event.target.value
                            onChangeField("address2", value)
                        }}

                    />
                </Grid>

                <Grid item xs={12} >
                    <Button fullWidth
                        disabled={!checkValidate(props.fields)}
                        color="success" variant="contained"
                        onClick={() => {
                            next(props.fields)
                        }}
                    >
                        <Typography variant="button" color="#fff">Next</Typography>
                    </Button>
                </Grid>
            </Grid>


            {/* </CardContent> */}
        </Box>
    );
}

export default AddressTab
export { AddressTab }
